export default "__VITE_ASSET__CvU1Q3DU__"